import React from 'react';
import './contacto.css';

function Contacto() {
  return (
    <section className="contact-section">
      <div className="form-container">
        <h3 style={{ fontSize: '40px', color: '#6cc24a' }}>Contáctanos</h3>
        <h2>Reúnete con uno de nuestros expertos</h2>
        <p className="description">
          Llena el siguiente formulario y te contactaremos a la brevedad posible o puedes llamar al teléfono de contacto.
        </p>

        <form className="contact-form">
          <label>Nombre *</label>
          <input type="text" required />

          <label>Teléfono *</label>
          <input type="tel" required />

          <label>Email *</label>
          <input type="email" required />

          <label>Mensaje</label>
          <textarea rows="4"></textarea>

          <button className='button-form' type="submit">ENVIAR</button>
        </form>
      </div>

      <div className="info-container">
        <div>
        <br />
        <br />
          <h3>LLÁMANOS</h3>
          <p className="phone-number">(664) 379-0668</p>
        </div>
        <div>
        <br />
        <br />
          <h3>LOCALIZACIÓN</h3>
          <p>
            Av. Águila #7080,<br />
            Local 9-A y 10-A,<br />
            Fracc. Guaycura. Tijuana B.C.
          </p>
        </div>
        <div>
        <br />
        <br />
          <h3>NUESTROS MEJORES SERVICIOS</h3>
          <ul className="services-list">
            <li>Venta de máquinas de coser</li>
            <li>Refacciones | Herramientas</li>
            <li>Reparación y mantenimiento</li>
          </ul>
        </div>

      </div>
      <div className='map-container'>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3365.271738992142!2d-116.91565492382318!3d32.4921654984878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d9390b6d492ceb%3A0x5bd943b529e342ad!2sGis%20Sewing%20Machine%20%26%20JUKI!5e0!3m2!1ses-419!2smx!4v1729652734758!5m2!1ses-419!2smx"
          width="100%"
          height="100%"
          style={{ border: 'none'}}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Mapa de ubicación de Gis Sewing Machine"
        ></iframe>
      </div>
    </section>
  );
}

export default Contacto;

  